import { render, staticRenderFns } from "./LectureExtraMaterialView.vue?vue&type=template&id=68689c70&"
import script from "./LectureExtraMaterialView.vue?vue&type=script&lang=ts&"
export * from "./LectureExtraMaterialView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports